var cov_2i51k2qc93 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Result.tsx",
      hash = "fc413dd0aae2ff44e06fc29e16dd6701992eeef7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Result.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 36
        },
        end: {
          line: 17,
          column: 58
        }
      },
      "1": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "2": {
        start: {
          line: 24,
          column: 40
        },
        end: {
          line: 24,
          column: 62
        }
      },
      "3": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 90
        }
      },
      "5": {
        start: {
          line: 27,
          column: 47
        },
        end: {
          line: 27,
          column: 90
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 48
        }
      },
      "7": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 35
        }
      },
      "8": {
        start: {
          line: 49,
          column: 16
        },
        end: {
          line: 49,
          column: 20
        }
      },
      "9": {
        start: {
          line: 50,
          column: 16
        },
        end: {
          line: 50,
          column: 80
        }
      },
      "10": {
        start: {
          line: 50,
          column: 57
        },
        end: {
          line: 50,
          column: 80
        }
      },
      "11": {
        start: {
          line: 51,
          column: 22
        },
        end: {
          line: 51,
          column: 40
        }
      },
      "12": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "13": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 16
        }
      },
      "14": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "15": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 52
        }
      },
      "16": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 48
        }
      },
      "17": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "18": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 46
        }
      },
      "19": {
        start: {
          line: 91,
          column: 27
        },
        end: {
          line: 91,
          column: 37
        }
      },
      "20": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "21": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 102
        }
      },
      "22": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 29
        }
      },
      "23": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 62
        }
      },
      "24": {
        start: {
          line: 102,
          column: 35
        },
        end: {
          line: 102,
          column: 62
        }
      },
      "25": {
        start: {
          line: 106,
          column: 32
        },
        end: {
          line: 106,
          column: 42
        }
      },
      "26": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "27": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 28
        }
      },
      "28": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 26
        }
      },
      "29": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 22
        }
      },
      "30": {
        start: {
          line: 118,
          column: 66
        },
        end: {
          line: 118,
          column: 76
        }
      },
      "31": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "32": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 122,
          column: 7
        }
      },
      "33": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 14
        }
      },
      "34": {
        start: {
          line: 123,
          column: 23
        },
        end: {
          line: 123,
          column: 28
        }
      },
      "35": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 145,
          column: 7
        }
      },
      "36": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 25
        }
      },
      "37": {
        start: {
          line: 126,
          column: 13
        },
        end: {
          line: 145,
          column: 7
        }
      },
      "38": {
        start: {
          line: 127,
          column: 16
        },
        end: {
          line: 127,
          column: 42
        }
      },
      "39": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 144,
          column: 9
        }
      },
      "40": {
        start: {
          line: 129,
          column: 32
        },
        end: {
          line: 133,
          column: 11
        }
      },
      "41": {
        start: {
          line: 130,
          column: 34
        },
        end: {
          line: 130,
          column: 53
        }
      },
      "42": {
        start: {
          line: 132,
          column: 12
        },
        end: {
          line: 132,
          column: 101
        }
      },
      "43": {
        start: {
          line: 134,
          column: 29
        },
        end: {
          line: 138,
          column: 66
        }
      },
      "44": {
        start: {
          line: 138,
          column: 15
        },
        end: {
          line: 138,
          column: 66
        }
      },
      "45": {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 142,
          column: 11
        }
      },
      "46": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 29
        }
      },
      "47": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 17
        }
      },
      "48": {
        start: {
          line: 143,
          column: 10
        },
        end: {
          line: 143,
          column: 16
        }
      },
      "49": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 158,
          column: 7
        }
      },
      "50": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 24
        }
      },
      "51": {
        start: {
          line: 149,
          column: 13
        },
        end: {
          line: 158,
          column: 7
        }
      },
      "52": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 150,
          column: 36
        }
      },
      "53": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 156,
          column: 9
        }
      },
      "54": {
        start: {
          line: 157,
          column: 8
        },
        end: {
          line: 157,
          column: 26
        }
      },
      "55": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 163,
          column: 38
        }
      },
      "56": {
        start: {
          line: 163,
          column: 32
        },
        end: {
          line: 163,
          column: 38
        }
      },
      "57": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 31
        }
      },
      "58": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 24
        }
      },
      "59": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 22
        }
      },
      "60": {
        start: {
          line: 171,
          column: 25
        },
        end: {
          line: 171,
          column: 35
        }
      },
      "61": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 18
        }
      },
      "62": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 27
        }
      },
      "63": {
        start: {
          line: 180,
          column: 32
        },
        end: {
          line: 180,
          column: 42
        }
      },
      "64": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 181,
          column: 79
        }
      },
      "65": {
        start: {
          line: 185,
          column: 42
        },
        end: {
          line: 185,
          column: 52
        }
      },
      "66": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 194,
          column: 5
        }
      },
      "67": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 192,
          column: 7
        }
      },
      "68": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 15
        }
      },
      "69": {
        start: {
          line: 200,
          column: 57
        },
        end: {
          line: 200,
          column: 67
        }
      },
      "70": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "71": {
        start: {
          line: 215,
          column: 53
        },
        end: {
          line: 215,
          column: 63
        }
      },
      "72": {
        start: {
          line: 216,
          column: 20
        },
        end: {
          line: 216,
          column: 73
        }
      },
      "73": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 217,
          column: 37
        }
      },
      "74": {
        start: {
          line: 217,
          column: 26
        },
        end: {
          line: 217,
          column: 37
        }
      },
      "75": {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 218,
          column: 31
        }
      },
      "76": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 229,
          column: 5
        }
      },
      "77": {
        start: {
          line: 233,
          column: 27
        },
        end: {
          line: 233,
          column: 37
        }
      },
      "78": {
        start: {
          line: 234,
          column: 17
        },
        end: {
          line: 234,
          column: 42
        }
      },
      "79": {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 246,
          column: 5
        }
      },
      "80": {
        start: {
          line: 250,
          column: 44
        },
        end: {
          line: 250,
          column: 54
        }
      },
      "81": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 254,
          column: 5
        }
      },
      "82": {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 253,
          column: 34
        }
      },
      "83": {
        start: {
          line: 256,
          column: 4
        },
        end: {
          line: 268,
          column: 5
        }
      },
      "84": {
        start: {
          line: 272,
          column: 105
        },
        end: {
          line: 272,
          column: 115
        }
      },
      "85": {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 286,
          column: 5
        }
      },
      "86": {
        start: {
          line: 275,
          column: 18
        },
        end: {
          line: 275,
          column: 86
        }
      },
      "87": {
        start: {
          line: 275,
          column: 39
        },
        end: {
          line: 275,
          column: 60
        }
      },
      "88": {
        start: {
          line: 275,
          column: 74
        },
        end: {
          line: 275,
          column: 85
        }
      },
      "89": {
        start: {
          line: 277,
          column: 6
        },
        end: {
          line: 279,
          column: 7
        }
      },
      "90": {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 278,
          column: 38
        }
      },
      "91": {
        start: {
          line: 281,
          column: 6
        },
        end: {
          line: 283,
          column: 7
        }
      },
      "92": {
        start: {
          line: 282,
          column: 8
        },
        end: {
          line: 282,
          column: 63
        }
      },
      "93": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 285,
          column: 18
        }
      },
      "94": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 290,
          column: 5
        }
      },
      "95": {
        start: {
          line: 289,
          column: 6
        },
        end: {
          line: 289,
          column: 89
        }
      },
      "96": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 294,
          column: 5
        }
      },
      "97": {
        start: {
          line: 298,
          column: 28
        },
        end: {
          line: 298,
          column: 58
        }
      },
      "98": {
        start: {
          line: 299,
          column: 24
        },
        end: {
          line: 299,
          column: 63
        }
      },
      "99": {
        start: {
          line: 300,
          column: 19
        },
        end: {
          line: 300,
          column: 63
        }
      },
      "100": {
        start: {
          line: 301,
          column: 56
        },
        end: {
          line: 301,
          column: 66
        }
      },
      "101": {
        start: {
          line: 302,
          column: 17
        },
        end: {
          line: 302,
          column: 56
        }
      },
      "102": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 328,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 26
          },
          end: {
            line: 19,
            column: 27
          }
        },
        loc: {
          start: {
            line: 23,
            column: 22
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "Item",
        decl: {
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 13
          }
        },
        loc: {
          start: {
            line: 48,
            column: 3
          },
          end: {
            line: 66,
            column: 1
          }
        },
        line: 48
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 50,
            column: 51
          },
          end: {
            line: 50,
            column: 52
          }
        },
        loc: {
          start: {
            line: 50,
            column: 57
          },
          end: {
            line: 50,
            column: 80
          }
        },
        line: 50
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 47
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 79
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 90
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 57
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 97
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 25
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 101
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 23
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 105
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 33
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 113
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        loc: {
          start: {
            line: 117,
            column: 49
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 117
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 129,
            column: 32
          },
          end: {
            line: 129,
            column: 33
          }
        },
        loc: {
          start: {
            line: 129,
            column: 96
          },
          end: {
            line: 133,
            column: 11
          }
        },
        line: 129
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 134,
            column: 29
          },
          end: {
            line: 134,
            column: 30
          }
        },
        loc: {
          start: {
            line: 138,
            column: 15
          },
          end: {
            line: 138,
            column: 66
          }
        },
        line: 138
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 162,
            column: 2
          },
          end: {
            line: 162,
            column: 3
          }
        },
        loc: {
          start: {
            line: 162,
            column: 14
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 162
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 170,
            column: 3
          }
        },
        loc: {
          start: {
            line: 170,
            column: 39
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 170
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 27
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 175
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 22
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 179
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 184,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        },
        loc: {
          start: {
            line: 184,
            column: 16
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 184
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 199,
            column: 3
          }
        },
        loc: {
          start: {
            line: 199,
            column: 69
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 199
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 53
          },
          end: {
            line: 230,
            column: 3
          }
        },
        line: 214
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 232,
            column: 2
          },
          end: {
            line: 232,
            column: 3
          }
        },
        loc: {
          start: {
            line: 232,
            column: 39
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 232
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 249,
            column: 2
          },
          end: {
            line: 249,
            column: 3
          }
        },
        loc: {
          start: {
            line: 249,
            column: 47
          },
          end: {
            line: 269,
            column: 3
          }
        },
        line: 249
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 271,
            column: 2
          },
          end: {
            line: 271,
            column: 3
          }
        },
        loc: {
          start: {
            line: 271,
            column: 17
          },
          end: {
            line: 295,
            column: 3
          }
        },
        line: 271
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 275,
            column: 29
          },
          end: {
            line: 275,
            column: 30
          }
        },
        loc: {
          start: {
            line: 275,
            column: 39
          },
          end: {
            line: 275,
            column: 60
          }
        },
        line: 275
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 275,
            column: 69
          },
          end: {
            line: 275,
            column: 70
          }
        },
        loc: {
          start: {
            line: 275,
            column: 74
          },
          end: {
            line: 275,
            column: 85
          }
        },
        line: 275
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 3
          }
        },
        loc: {
          start: {
            line: 297,
            column: 11
          },
          end: {
            line: 329,
            column: 3
          }
        },
        line: 297
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 29
          }
        }, {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 26,
            column: 67
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 90
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 90
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 90
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 30,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 29,
            column: 49
          }
        }, {
          start: {
            line: 30,
            column: 9
          },
          end: {
            line: 30,
            column: 47
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 39
          },
          end: {
            line: 50,
            column: 48
          }
        }, {
          start: {
            line: 50,
            column: 51
          },
          end: {
            line: 50,
            column: 80
          }
        }],
        line: 50
      },
      "5": {
        loc: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 24
          }
        }, {
          start: {
            line: 50,
            column: 28
          },
          end: {
            line: 50,
            column: 36
          }
        }],
        line: 50
      },
      "6": {
        loc: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 30
          }
        }, {
          start: {
            line: 51,
            column: 34
          },
          end: {
            line: 51,
            column: 40
          }
        }],
        line: 51
      },
      "7": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 16
          }
        }, {
          start: {
            line: 57,
            column: 20
          },
          end: {
            line: 57,
            column: 49
          }
        }],
        line: 57
      },
      "8": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 19
          }
        }, {
          start: {
            line: 58,
            column: 23
          },
          end: {
            line: 58,
            column: 47
          }
        }],
        line: 58
      },
      "9": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 12
          }
        }, {
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 27
          }
        }],
        line: 59
      },
      "10": {
        loc: {
          start: {
            line: 63,
            column: 7
          },
          end: {
            line: 63,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 7
          },
          end: {
            line: 63,
            column: 19
          }
        }, {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 63,
            column: 97
          }
        }],
        line: 63
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 18
          }
        }, {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 47
          }
        }],
        line: 92
      },
      "13": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 62
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 62
          }
        }],
        line: 102
      },
      "14": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }],
        line: 107
      },
      "15": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }],
        line: 119
      },
      "16": {
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        }],
        line: 120
      },
      "17": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }, {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }],
        line: 124
      },
      "18": {
        loc: {
          start: {
            line: 124,
            column: 10
          },
          end: {
            line: 124,
            column: 106
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 10
          },
          end: {
            line: 124,
            column: 50
          }
        }, {
          start: {
            line: 124,
            column: 54
          },
          end: {
            line: 124,
            column: 106
          }
        }],
        line: 124
      },
      "19": {
        loc: {
          start: {
            line: 124,
            column: 55
          },
          end: {
            line: 124,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 55
          },
          end: {
            line: 124,
            column: 59
          }
        }, {
          start: {
            line: 124,
            column: 63
          },
          end: {
            line: 124,
            column: 65
          }
        }],
        line: 124
      },
      "20": {
        loc: {
          start: {
            line: 124,
            column: 79
          },
          end: {
            line: 124,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 79
          },
          end: {
            line: 124,
            column: 92
          }
        }, {
          start: {
            line: 124,
            column: 96
          },
          end: {
            line: 124,
            column: 98
          }
        }],
        line: 124
      },
      "21": {
        loc: {
          start: {
            line: 126,
            column: 13
          },
          end: {
            line: 145,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 13
          },
          end: {
            line: 145,
            column: 7
          }
        }, {
          start: {
            line: 126,
            column: 13
          },
          end: {
            line: 145,
            column: 7
          }
        }],
        line: 126
      },
      "22": {
        loc: {
          start: {
            line: 132,
            column: 19
          },
          end: {
            line: 132,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 40
          },
          end: {
            line: 132,
            column: 67
          }
        }, {
          start: {
            line: 132,
            column: 70
          },
          end: {
            line: 132,
            column: 101
          }
        }],
        line: 132
      },
      "23": {
        loc: {
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 142,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 142,
            column: 11
          }
        }, {
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 142,
            column: 11
          }
        }],
        line: 139
      },
      "24": {
        loc: {
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 158,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 158,
            column: 7
          }
        }, {
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 158,
            column: 7
          }
        }],
        line: 147
      },
      "25": {
        loc: {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 158,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 158,
            column: 7
          }
        }, {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 158,
            column: 7
          }
        }],
        line: 149
      },
      "26": {
        loc: {
          start: {
            line: 149,
            column: 17
          },
          end: {
            line: 149,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 17
          },
          end: {
            line: 149,
            column: 30
          }
        }, {
          start: {
            line: 149,
            column: 34
          },
          end: {
            line: 149,
            column: 54
          }
        }],
        line: 149
      },
      "27": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 38
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 38
          }
        }],
        line: 163
      },
      "28": {
        loc: {
          start: {
            line: 181,
            column: 11
          },
          end: {
            line: 181,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 11
          },
          end: {
            line: 181,
            column: 26
          }
        }, {
          start: {
            line: 181,
            column: 30
          },
          end: {
            line: 181,
            column: 55
          }
        }, {
          start: {
            line: 181,
            column: 59
          },
          end: {
            line: 181,
            column: 79
          }
        }],
        line: 181
      },
      "29": {
        loc: {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }, {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }],
        line: 186
      },
      "30": {
        loc: {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 15
          }
        }, {
          start: {
            line: 186,
            column: 19
          },
          end: {
            line: 186,
            column: 36
          }
        }, {
          start: {
            line: 186,
            column: 40
          },
          end: {
            line: 186,
            column: 57
          }
        }],
        line: 186
      },
      "31": {
        loc: {
          start: {
            line: 199,
            column: 37
          },
          end: {
            line: 199,
            column: 67
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 199,
            column: 60
          },
          end: {
            line: 199,
            column: 67
          }
        }],
        line: 199
      },
      "32": {
        loc: {
          start: {
            line: 203,
            column: 23
          },
          end: {
            line: 203,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 203,
            column: 31
          },
          end: {
            line: 203,
            column: 32
          }
        }, {
          start: {
            line: 203,
            column: 35
          },
          end: {
            line: 203,
            column: 36
          }
        }],
        line: 203
      },
      "33": {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 217,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 217,
            column: 37
          }
        }, {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 217,
            column: 37
          }
        }],
        line: 217
      },
      "34": {
        loc: {
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        }, {
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 254,
            column: 5
          }
        }],
        line: 252
      },
      "35": {
        loc: {
          start: {
            line: 252,
            column: 8
          },
          end: {
            line: 252,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 252,
            column: 8
          },
          end: {
            line: 252,
            column: 13
          }
        }, {
          start: {
            line: 252,
            column: 17
          },
          end: {
            line: 252,
            column: 25
          }
        }, {
          start: {
            line: 252,
            column: 29
          },
          end: {
            line: 252,
            column: 44
          }
        }],
        line: 252
      },
      "36": {
        loc: {
          start: {
            line: 258,
            column: 15
          },
          end: {
            line: 258,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 258,
            column: 33
          },
          end: {
            line: 258,
            column: 42
          }
        }, {
          start: {
            line: 258,
            column: 45
          },
          end: {
            line: 258,
            column: 64
          }
        }],
        line: 258
      },
      "37": {
        loc: {
          start: {
            line: 262,
            column: 10
          },
          end: {
            line: 262,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 262,
            column: 10
          },
          end: {
            line: 262,
            column: 20
          }
        }, {
          start: {
            line: 262,
            column: 24
          },
          end: {
            line: 262,
            column: 50
          }
        }],
        line: 262
      },
      "38": {
        loc: {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }, {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }],
        line: 274
      },
      "39": {
        loc: {
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        }, {
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        }],
        line: 277
      },
      "40": {
        loc: {
          start: {
            line: 281,
            column: 6
          },
          end: {
            line: 283,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 6
          },
          end: {
            line: 283,
            column: 7
          }
        }, {
          start: {
            line: 281,
            column: 6
          },
          end: {
            line: 283,
            column: 7
          }
        }],
        line: 281
      },
      "41": {
        loc: {
          start: {
            line: 281,
            column: 10
          },
          end: {
            line: 281,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 10
          },
          end: {
            line: 281,
            column: 15
          }
        }, {
          start: {
            line: 281,
            column: 19
          },
          end: {
            line: 281,
            column: 27
          }
        }],
        line: 281
      },
      "42": {
        loc: {
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        }, {
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        }],
        line: 288
      },
      "43": {
        loc: {
          start: {
            line: 300,
            column: 19
          },
          end: {
            line: 300,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 300,
            column: 37
          },
          end: {
            line: 300,
            column: 41
          }
        }, {
          start: {
            line: 300,
            column: 44
          },
          end: {
            line: 300,
            column: 63
          }
        }],
        line: 300
      },
      "44": {
        loc: {
          start: {
            line: 302,
            column: 17
          },
          end: {
            line: 302,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 302,
            column: 18
          },
          end: {
            line: 302,
            column: 26
          }
        }, {
          start: {
            line: 302,
            column: 30
          },
          end: {
            line: 302,
            column: 35
          }
        }, {
          start: {
            line: 302,
            column: 40
          },
          end: {
            line: 302,
            column: 56
          }
        }],
        line: 302
      },
      "45": {
        loc: {
          start: {
            line: 313,
            column: 57
          },
          end: {
            line: 313,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 57
          },
          end: {
            line: 313,
            column: 67
          }
        }, {
          start: {
            line: 313,
            column: 71
          },
          end: {
            line: 313,
            column: 83
          }
        }],
        line: 313
      },
      "46": {
        loc: {
          start: {
            line: 313,
            column: 85
          },
          end: {
            line: 313,
            column: 111
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 85
          },
          end: {
            line: 313,
            column: 100
          }
        }, {
          start: {
            line: 313,
            column: 104
          },
          end: {
            line: 313,
            column: 111
          }
        }],
        line: 313
      },
      "47": {
        loc: {
          start: {
            line: 314,
            column: 12
          },
          end: {
            line: 314,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 314,
            column: 12
          },
          end: {
            line: 314,
            column: 22
          }
        }, {
          start: {
            line: 314,
            column: 26
          },
          end: {
            line: 314,
            column: 56
          }
        }],
        line: 314
      },
      "48": {
        loc: {
          start: {
            line: 319,
            column: 11
          },
          end: {
            line: 324,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 319,
            column: 11
          },
          end: {
            line: 319,
            column: 31
          }
        }, {
          start: {
            line: 321,
            column: 12
          },
          end: {
            line: 323,
            column: 16
          }
        }],
        line: 319
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0, 0],
      "31": [0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Result.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { addResizeObserver } from '../utils/dom/element';
import { treeSelectClass } from './styles';
import { inputClass } from '../Input/styles';
import { inputTitleClass } from '../InputTitle/styles';
import { isEmpty, isObject, isNumber } from '../utils/is';
import Input from './Input';
import Caret from '../icons/Caret';
import More, { getResetMore } from '../Select/More';
import InputTitle from '../InputTitle';
import { getKey } from '../utils/uid';
import { getDirectionClass } from '../utils/classname';
export var IS_NOT_MATCHED_VALUE = (cov_2i51k2qc93.s[0]++, 'IS_NOT_MATCHED_VALUE');
cov_2i51k2qc93.s[1]++;

var getResultContent = function getResultContent(data, renderResult, renderUnmatched) {
  cov_2i51k2qc93.f[0]++;
  var unMatchedData = (cov_2i51k2qc93.s[2]++, data);
  cov_2i51k2qc93.s[3]++;

  if ((cov_2i51k2qc93.b[1][0]++, isObject(unMatchedData)) && (cov_2i51k2qc93.b[1][1]++, unMatchedData.IS_NOT_MATCHED_VALUE)) {
    cov_2i51k2qc93.b[0][0]++;
    cov_2i51k2qc93.s[4]++;

    if (typeof renderUnmatched === 'function') {
      cov_2i51k2qc93.b[2][0]++;
      cov_2i51k2qc93.s[5]++;
      return renderUnmatched(unMatchedData.value);
    } else {
      cov_2i51k2qc93.b[2][1]++;
    }

    cov_2i51k2qc93.s[6]++;
    return isObject(unMatchedData.value) ? (cov_2i51k2qc93.b[3][0]++, renderResult(unMatchedData.value)) : (cov_2i51k2qc93.b[3][1]++, unMatchedData.value);
  } else {
    cov_2i51k2qc93.b[0][1]++;
  }

  cov_2i51k2qc93.s[7]++;
  return renderResult(data);
}; // eslint-disable-next-line


function Item(_ref) {
  var content = _ref.content,
      data = _ref.data,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      only = _ref.only;
  cov_2i51k2qc93.f[1]++;
  var value = (cov_2i51k2qc93.s[8]++, data);
  var click = (cov_2i51k2qc93.s[9]++, (cov_2i51k2qc93.b[5][0]++, disabled) || (cov_2i51k2qc93.b[5][1]++, !onClick) ? (cov_2i51k2qc93.b[4][0]++, undefined) : (cov_2i51k2qc93.b[4][1]++, function () {
    cov_2i51k2qc93.f[2]++;
    cov_2i51k2qc93.s[10]++;
    return onClick(value);
  }));
  var synDisabled = (cov_2i51k2qc93.s[11]++, (cov_2i51k2qc93.b[6][0]++, disabled) || (cov_2i51k2qc93.b[6][1]++, !click));
  cov_2i51k2qc93.s[12]++;
  return (
    /*#__PURE__*/
    React.createElement("a", {
      tabIndex: -1,
      className: treeSelectClass(getDirectionClass('item'), (cov_2i51k2qc93.b[7][0]++, disabled) && (cov_2i51k2qc93.b[7][1]++, getDirectionClass('disabled')), (cov_2i51k2qc93.b[8][0]++, synDisabled) && (cov_2i51k2qc93.b[8][1]++, getDirectionClass('ban')), (cov_2i51k2qc93.b[9][0]++, only) && (cov_2i51k2qc93.b[9][1]++, 'item-only')),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 5
      }
    }, content, (cov_2i51k2qc93.b[10][0]++, !synDisabled) && (cov_2i51k2qc93.b[10][1]++,
    /*#__PURE__*/
    React.createElement("span", {
      className: treeSelectClass('indicator', 'close'),
      onClick: click,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 24
      }
    })))
  );
}

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    cov_2i51k2qc93.f[3]++;
    cov_2i51k2qc93.s[13]++;
    _this = _super.call(this, props);
    _this.resultEl = void 0;
    _this.cancelResizeObserver = void 0;
    _this.shouldResetMore = void 0;
    cov_2i51k2qc93.s[14]++;
    _this.state = {
      more: -1
    };
    cov_2i51k2qc93.s[15]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    cov_2i51k2qc93.s[16]++;
    _this.handelMore = _this.handelMore.bind(_assertThisInitialized(_this));
    cov_2i51k2qc93.s[17]++;
    _this.bindResult = _this.bindResult.bind(_assertThisInitialized(_this));
    cov_2i51k2qc93.s[18]++;
    _this.resetMore = _this.resetMore.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2i51k2qc93.f[4]++;

      var _ref2 = (cov_2i51k2qc93.s[19]++, this.props),
          compressed = _ref2.compressed;

      cov_2i51k2qc93.s[20]++;

      if ((cov_2i51k2qc93.b[12][0]++, compressed) && (cov_2i51k2qc93.b[12][1]++, !this.isCompressedBound())) {
        cov_2i51k2qc93.b[11][0]++;
        cov_2i51k2qc93.s[21]++;
        this.cancelResizeObserver = addResizeObserver(this.resultEl, this.resetMore, {
          direction: 'x'
        });
      } else {
        cov_2i51k2qc93.b[11][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      cov_2i51k2qc93.f[5]++;
      cov_2i51k2qc93.s[22]++;
      this.updateMore(preProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2i51k2qc93.f[6]++;
      cov_2i51k2qc93.s[23]++;

      if (this.cancelResizeObserver) {
        cov_2i51k2qc93.b[13][0]++;
        cov_2i51k2qc93.s[24]++;
        this.cancelResizeObserver();
      } else {
        cov_2i51k2qc93.b[13][1]++;
      }
    }
  }, {
    key: "getCompressedBound",
    value: function getCompressedBound() {
      cov_2i51k2qc93.f[7]++;

      var _ref3 = (cov_2i51k2qc93.s[25]++, this.props),
          compressedBound = _ref3.compressedBound;

      cov_2i51k2qc93.s[26]++;

      if (this.isCompressedBound()) {
        cov_2i51k2qc93.b[14][0]++;
        cov_2i51k2qc93.s[27]++;
        return compressedBound;
      } else {
        cov_2i51k2qc93.b[14][1]++;
      }

      cov_2i51k2qc93.s[28]++;
      return this.state.more;
    }
  }, {
    key: "bindResult",
    value: function bindResult(el) {
      cov_2i51k2qc93.f[8]++;
      cov_2i51k2qc93.s[29]++;
      this.resultEl = el;
    }
  }, {
    key: "updateMore",
    value: function updateMore(preProps) {
      cov_2i51k2qc93.f[9]++;

      var _ref4 = (cov_2i51k2qc93.s[30]++, this.props),
          result = _ref4.result,
          compressed = _ref4.compressed,
          onFilter = _ref4.onFilter,
          keygen = _ref4.keygen,
          data = _ref4.data,
          datum = _ref4.datum;

      cov_2i51k2qc93.s[31]++;

      if (compressed) {
        cov_2i51k2qc93.b[15][0]++;
        cov_2i51k2qc93.s[32]++;

        if (this.isCompressedBound()) {
          cov_2i51k2qc93.b[16][0]++;
          cov_2i51k2qc93.s[33]++;
          return;
        } else {
          cov_2i51k2qc93.b[16][1]++;
        }

        var shouldRest = (cov_2i51k2qc93.s[34]++, false);
        cov_2i51k2qc93.s[35]++;

        if ((cov_2i51k2qc93.b[18][0]++, preProps.result.length !== result.length) || (cov_2i51k2qc93.b[18][1]++, ((cov_2i51k2qc93.b[19][0]++, data) || (cov_2i51k2qc93.b[19][1]++, [])).length !== ((cov_2i51k2qc93.b[20][0]++, preProps.data) || (cov_2i51k2qc93.b[20][1]++, [])).length)) {
          cov_2i51k2qc93.b[17][0]++;
          cov_2i51k2qc93.s[36]++;
          shouldRest = true;
        } else {
          cov_2i51k2qc93.b[17][1]++;
          cov_2i51k2qc93.s[37]++;

          if (preProps.result !== result) {
            cov_2i51k2qc93.b[21][0]++;
            var i = (cov_2i51k2qc93.s[38]++, preProps.result.length - 1);
            cov_2i51k2qc93.s[39]++;

            var _loop = function _loop() {
              cov_2i51k2qc93.s[40]++;

              var getUnMatchKey = function getUnMatchKey(d, k) {
                cov_2i51k2qc93.f[10]++;
                var unMatchedData = (cov_2i51k2qc93.s[41]++, d);
                cov_2i51k2qc93.s[42]++;
                return datum.isUnMatch(d) ? (cov_2i51k2qc93.b[22][0]++, d.value) : (cov_2i51k2qc93.b[22][1]++, getKey(unMatchedData, k));
              };

              cov_2i51k2qc93.s[43]++;

              var isSameData = function isSameData(data1, data2, k) {
                cov_2i51k2qc93.f[11]++;
                cov_2i51k2qc93.s[44]++;
                return getUnMatchKey(data1, k) === getUnMatchKey(data2, k);
              };

              cov_2i51k2qc93.s[45]++;

              if (!isSameData(result[i], preProps.result[i], keygen)) {
                cov_2i51k2qc93.b[23][0]++;
                cov_2i51k2qc93.s[46]++;
                shouldRest = true;
                cov_2i51k2qc93.s[47]++;
                return "break";
              } else {
                cov_2i51k2qc93.b[23][1]++;
              }

              cov_2i51k2qc93.s[48]++;
              i -= 1;
            };

            while (i >= 0) {
              var _ret = _loop();

              if (_ret === "break") break;
            }
          } else {
            cov_2i51k2qc93.b[21][1]++;
          }
        }

        cov_2i51k2qc93.s[49]++;

        if (shouldRest) {
          cov_2i51k2qc93.b[24][0]++;
          cov_2i51k2qc93.s[50]++;
          this.resetMore();
        } else {
          cov_2i51k2qc93.b[24][1]++;
          cov_2i51k2qc93.s[51]++;

          if ((cov_2i51k2qc93.b[26][0]++, result.length) && (cov_2i51k2qc93.b[26][1]++, this.shouldResetMore)) {
            cov_2i51k2qc93.b[25][0]++;
            cov_2i51k2qc93.s[52]++;
            this.shouldResetMore = false; // @ts-ignore

            cov_2i51k2qc93.s[53]++;
            this.state.more = getResetMore(onFilter, this.resultEl, this.resultEl.querySelectorAll(".".concat(treeSelectClass('item'))));
            cov_2i51k2qc93.s[54]++;
            this.forceUpdate();
          } else {
            cov_2i51k2qc93.b[25][1]++;
          }
        }
      } else {
        cov_2i51k2qc93.b[15][1]++;
      }
    }
  }, {
    key: "resetMore",
    value: function resetMore() {
      cov_2i51k2qc93.f[12]++;
      cov_2i51k2qc93.s[55]++;

      if (!this.props.compressed) {
        cov_2i51k2qc93.b[27][0]++;
        cov_2i51k2qc93.s[56]++;
        return;
      } else {
        cov_2i51k2qc93.b[27][1]++;
      }

      cov_2i51k2qc93.s[57]++;
      this.shouldResetMore = true; // @ts-ignore

      cov_2i51k2qc93.s[58]++;
      this.state.more = -1;
      cov_2i51k2qc93.s[59]++;
      this.forceUpdate();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(data) {
      cov_2i51k2qc93.f[13]++;

      var _ref5 = (cov_2i51k2qc93.s[60]++, this.props),
          onRemove = _ref5.onRemove;

      cov_2i51k2qc93.s[61]++;
      onRemove(data);
    }
  }, {
    key: "handelMore",
    value: function handelMore(more) {
      cov_2i51k2qc93.f[14]++;
      cov_2i51k2qc93.s[62]++;
      this.setState({
        more: more
      });
    }
  }, {
    key: "isCompressedBound",
    value: function isCompressedBound() {
      cov_2i51k2qc93.f[15]++;

      var _ref6 = (cov_2i51k2qc93.s[63]++, this.props),
          compressedBound = _ref6.compressedBound;

      cov_2i51k2qc93.s[64]++;
      return (cov_2i51k2qc93.b[28][0]++, compressedBound) && (cov_2i51k2qc93.b[28][1]++, isNumber(compressedBound)) && (cov_2i51k2qc93.b[28][2]++, compressedBound >= 1);
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      cov_2i51k2qc93.f[16]++;

      var _ref7 = (cov_2i51k2qc93.s[65]++, this.props),
          onClear = _ref7.onClear,
          result = _ref7.result,
          disabled = _ref7.disabled;

      cov_2i51k2qc93.s[66]++;

      if ((cov_2i51k2qc93.b[30][0]++, onClear) && (cov_2i51k2qc93.b[30][1]++, result.length > 0) && (cov_2i51k2qc93.b[30][2]++, disabled !== true)) {
        cov_2i51k2qc93.b[29][0]++;
        cov_2i51k2qc93.s[67]++;

        /* eslint-disable */
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: "clear",
            onClick: onClear,
            className: treeSelectClass('close-warpper'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 189,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement("a", {
            tabIndex: -1,
            "data-role": "close",
            className: treeSelectClass('indicator', 'close'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 190,
              columnNumber: 11
            }
          }))
        );
        /* eslint-enable */
      } else {
        cov_2i51k2qc93.b[29][1]++;
      }

      cov_2i51k2qc93.s[68]++;
      return null;
    }
  }, {
    key: "renderInput",
    value: function renderInput(text) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2i51k2qc93.b[31][0]++, 'input');
      cov_2i51k2qc93.f[17]++;

      var _ref8 = (cov_2i51k2qc93.s[69]++, this.props),
          multiple = _ref8.multiple,
          onFilter = _ref8.onFilter,
          focus = _ref8.focus,
          setInputReset = _ref8.setInputReset;

      cov_2i51k2qc93.s[70]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          key: "".concat(key, ".").concat(focus ? (cov_2i51k2qc93.b[32][0]++, 1) : (cov_2i51k2qc93.b[32][1]++, 0)),
          updatAble: !multiple,
          multiple: multiple,
          focus: focus,
          text: text,
          onFilter: onFilter,
          setInputReset: setInputReset,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderItem",
    value: function renderItem(data, index) {
      cov_2i51k2qc93.f[18]++;

      var _ref9 = (cov_2i51k2qc93.s[71]++, this.props),
          renderResult = _ref9.renderResult,
          renderUnmatched = _ref9.renderUnmatched,
          datum = _ref9.datum;

      var content = (cov_2i51k2qc93.s[72]++, getResultContent(data, renderResult, renderUnmatched));
      cov_2i51k2qc93.s[73]++;

      if (content === null) {
        cov_2i51k2qc93.b[33][0]++;
        cov_2i51k2qc93.s[74]++;
        return null;
      } else {
        cov_2i51k2qc93.b[33][1]++;
      }

      var _ref10 = (cov_2i51k2qc93.s[75]++, this.state),
          more = _ref10.more;

      cov_2i51k2qc93.s[76]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          only: more === 1,
          key: index,
          content: content,
          data: data,
          disabled: datum.disabled(data),
          onClick: this.handleRemove,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 221,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderMore",
    value: function renderMore(items) {
      cov_2i51k2qc93.f[19]++;

      var _ref11 = (cov_2i51k2qc93.s[77]++, this.props),
          compressed = _ref11.compressed;

      var more = (cov_2i51k2qc93.s[78]++, this.getCompressedBound());
      cov_2i51k2qc93.s[79]++;
      return [
      /*#__PURE__*/
      React.createElement(More, {
        key: "more",
        className: treeSelectClass(getDirectionClass('item'), 'item-compressed'),
        popoverClassName: treeSelectClass('popover'),
        contentClassName: treeSelectClass(getDirectionClass('result')),
        compressed: compressed,
        data: items,
        cls: treeSelectClass,
        showNum: more,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 236,
          columnNumber: 7
        }
      })];
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(showPlaceholder) {
      cov_2i51k2qc93.f[20]++;

      var _ref12 = (cov_2i51k2qc93.s[80]++, this.props),
          focus = _ref12.focus,
          onFilter = _ref12.onFilter,
          innerTitle = _ref12.innerTitle;

      cov_2i51k2qc93.s[81]++;

      if ((cov_2i51k2qc93.b[35][0]++, focus) && (cov_2i51k2qc93.b[35][1]++, onFilter) && (cov_2i51k2qc93.b[35][2]++, showPlaceholder)) {
        cov_2i51k2qc93.b[34][0]++;
        cov_2i51k2qc93.s[82]++;
        return this.renderInput(' ');
      } else {
        cov_2i51k2qc93.b[34][1]++;
      }

      cov_2i51k2qc93.s[83]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          style: showPlaceholder ? (cov_2i51k2qc93.b[36][0]++, undefined) : (cov_2i51k2qc93.b[36][1]++, {
            display: 'none'
          }),
          className: classnames(inputClass('placeholder'), treeSelectClass('ellipsis'), (cov_2i51k2qc93.b[37][0]++, innerTitle) && (cov_2i51k2qc93.b[37][1]++, inputTitleClass('hidable'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 257,
            columnNumber: 7
          }
        }, this.props.placeholder, "\xA0")
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this2 = this;

      cov_2i51k2qc93.f[21]++;

      var _ref13 = (cov_2i51k2qc93.s[84]++, this.props),
          multiple = _ref13.multiple,
          compressed = _ref13.compressed,
          result = _ref13.result,
          renderResult = _ref13.renderResult,
          renderUnmatched = _ref13.renderUnmatched,
          onFilter = _ref13.onFilter,
          focus = _ref13.focus,
          filterText = _ref13.filterText;

      cov_2i51k2qc93.s[85]++;

      if (multiple) {
        cov_2i51k2qc93.b[38][0]++;
        var items = (cov_2i51k2qc93.s[86]++, result.map(function (n, i) {
          cov_2i51k2qc93.f[22]++;
          cov_2i51k2qc93.s[87]++;
          return _this2.renderItem(n, i);
        }).filter(function (n) {
          cov_2i51k2qc93.f[23]++;
          cov_2i51k2qc93.s[88]++;
          return !isEmpty(n);
        }));
        cov_2i51k2qc93.s[89]++;

        if (compressed) {
          cov_2i51k2qc93.b[39][0]++;
          cov_2i51k2qc93.s[90]++;
          items = this.renderMore(items);
        } else {
          cov_2i51k2qc93.b[39][1]++;
        }

        cov_2i51k2qc93.s[91]++;

        if ((cov_2i51k2qc93.b[41][0]++, focus) && (cov_2i51k2qc93.b[41][1]++, onFilter)) {
          cov_2i51k2qc93.b[40][0]++;
          cov_2i51k2qc93.s[92]++;
          items.push(this.renderInput(filterText, result.length));
        } else {
          cov_2i51k2qc93.b[40][1]++;
        }

        cov_2i51k2qc93.s[93]++;
        return items;
      } else {
        cov_2i51k2qc93.b[38][1]++;
      }

      cov_2i51k2qc93.s[94]++;

      if (onFilter) {
        cov_2i51k2qc93.b[42][0]++;
        cov_2i51k2qc93.s[95]++;
        return this.renderInput(getResultContent(result[0], renderResult, renderUnmatched));
      } else {
        cov_2i51k2qc93.b[42][1]++;
      }

      cov_2i51k2qc93.s[96]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: treeSelectClass('ellipsis'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 293,
            columnNumber: 7
          }
        }, getResultContent(result[0], renderResult, renderUnmatched))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_2i51k2qc93.f[24]++;
      var showPlaceholder = (cov_2i51k2qc93.s[97]++, this.props.result.length === 0);
      var placeholder = (cov_2i51k2qc93.s[98]++, this.renderPlaceholder(showPlaceholder));
      var result = (cov_2i51k2qc93.s[99]++, showPlaceholder ? (cov_2i51k2qc93.b[43][0]++, null) : (cov_2i51k2qc93.b[43][1]++, this.renderResult()));

      var _ref14 = (cov_2i51k2qc93.s[100]++, this.props),
          compressed = _ref14.compressed,
          innerTitle = _ref14.innerTitle,
          focus = _ref14.focus,
          onFilter = _ref14.onFilter;

      var open = (cov_2i51k2qc93.s[101]++, (cov_2i51k2qc93.b[44][0]++, onFilter) && (cov_2i51k2qc93.b[44][1]++, focus) || (cov_2i51k2qc93.b[44][2]++, !showPlaceholder));
      cov_2i51k2qc93.s[102]++;
      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          innerTitle: innerTitle,
          open: open,
          className: treeSelectClass('title-box'),
          titleClass: treeSelectClass(getDirectionClass('title-box-title')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 304,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindResult,
          className: classnames(treeSelectClass(getDirectionClass('result'), (cov_2i51k2qc93.b[45][0]++, compressed) && (cov_2i51k2qc93.b[45][1]++, 'compressed'), (cov_2i51k2qc93.b[46][0]++, showPlaceholder) && (cov_2i51k2qc93.b[46][1]++, 'empty')), (cov_2i51k2qc93.b[47][0]++, innerTitle) && (cov_2i51k2qc93.b[47][1]++, inputTitleClass('item-scroll'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 310,
            columnNumber: 9
          }
        }, result, placeholder, (cov_2i51k2qc93.b[48][0]++, !this.props.multiple) && (cov_2i51k2qc93.b[48][1]++,
        /*#__PURE__*/
        // eslint-disable-next-line
        React.createElement("a", {
          tabIndex: -1,
          className: treeSelectClass('indicator', 'caret'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 321,
            columnNumber: 13
          }
        },
        /*#__PURE__*/
        React.createElement(Caret, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 322,
            columnNumber: 16
          }
        }))), this.renderClear()))
      );
    }
  }]);

  return Result;
}(PureComponent);

export default Result;